import { routes } from '@platform/core/lib/routes';
import { navMode } from '@platform/navigation';
import { appRoutes } from './appRoutes';

/**
 * Сторінка, яку відкриває режим навігації (UIUX top-bar: «Адміністратор — відкриває Адміністрування», «Налаштування рішення — відкриває
 * Налаштування»; прототип v4: persona admin → page adm, cust → page cust, решта → Головна). Чиста функція.
 */
export function modeHomePath(modeKey: string): string {
  const opens = navMode(modeKey).opens;
  if (opens === 'administration') return appRoutes.admin();
  if (opens === 'customization') return appRoutes.customize();
  return routes.home();
}
